import React from 'react'
import { config } from '../config/env'

export const EnvironmentBanner: React.FC = () => {
    const env = config.app.environment

    // Don't show banner in production
    if (env === 'production') {
        return null
    }

    const bannerConfig = {
        development: { className: 'env-banner-green', label: 'DEVELOPMENT' },
        staging: { className: 'env-banner-orange', label: 'STAGING' },
    }

    const currentConfig = bannerConfig[env as keyof typeof bannerConfig]

    if (!currentConfig) {
        return null
    }

    return (
        <div className={`env-banner ${currentConfig.className}`}>
            {currentConfig.label}
        </div>
    )
}
